export default __webpack_public_path__ + "static/media/dragFile.1464f786.png";